
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function Stats() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const stats = [
    { number: '15+', label: 'Years Experience', icon: 'ri-time-line' },
    { number: '99.9%', label: 'System Uptime', icon: 'ri-shield-check-line' },
    { number: '24/7', label: 'Technical Support', icon: 'ri-customer-service-line' },
    { number: '100+', label: 'Projects Delivered', icon: 'ri-checkbox-circle-line' },
  ];

  return (
    <section id="stats" className="py-16 lg:py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden" ref={ref}>
      {/* Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/2 left-0 w-72 h-72 bg-teal-500/10 rounded-full blur-3xl -translate-y-1/2"></div>
        <div className="absolute top-1/2 right-0 w-72 h-72 bg-cyan-500/10 rounded-full blur-3xl -translate-y-1/2"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="relative group"
            >
              <div className="flex flex-col items-center text-center py-6 px-4 lg:py-8 lg:px-6 rounded-xl bg-white/5 border border-white/10 hover:border-teal-400/30 hover:bg-white/10 transition-all duration-500">
                {/* Icon */}
                <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg mb-3 lg:mb-4 group-hover:scale-110 transition-transform duration-500">
                  <i className={`${stat.icon} text-lg lg:text-xl text-white`}></i>
                </div>

                {/* Number */}
                <div className="text-2xl lg:text-4xl font-bold text-white mb-1">
                  {stat.number}
                </div>

                {/* Label */}
                <div className="text-xs lg:text-sm font-medium text-slate-400">
                  {stat.label}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
